import Common from '@/Common/meta/index'
import IView from '@/Common/meta/iview'

export default {
  install(Vue) {
    Common(Vue)
    IView(Vue)
    Vue.prototype.ptw = {
      retail_price: 120,
      sell_volume: 120,
       
    },
    Vue.filter('date', date => {
      var date_ = new Date(date);
      var year = date_.getFullYear();
      var month = date_.getMonth() + 1;
      var day = date_.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;


      return year + "-" + month + "-" + day
    }),
    Vue.filter('time', date => {
      var date_ = new Date(date);
      var year = date_.getFullYear();
      var month = date_.getMonth() + 1;
      var day = date_.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;

      var hours = date_.getHours();
      var mins = date_.getMinutes();
      var secs = date_.getSeconds();
      if (hours < 10) hours = "0" + hours;
      if (mins < 10) mins = "0" + mins;
      if (secs < 10) secs = "0" + secs;
      return year + "-" + month + "-" + day + " " + hours + ":" + mins + ":" + secs;
    })

  }
}



// WEBPACK FOOTER //
// ./src/meta.js